// src/data/investment-data.ts
import type { Bilingual } from "@/types/home";

const CDN = "https://lh3.googleusercontent.com/aida-public";
const IMG = {
  tower: `${CDN}/AB6AXuBDssLwW0tK4BjXKBOej4mx7Tagul6oeugJXkVtQfWt_mYqJblmMAGQhb0OTgmg7XEdHMM_7DRXQPYZxVgS2IiCJOZW4DvIhcaRnaP--BiTT1gdfDuQoQILCwcxvHRt9Wzx2mFALcM-LsaKLwWNNjyDxAHy2bNEQVLsZDQQS8DCvPfG3AYv2HCtEbYVkXGu-cPXPcPKytt80yZchQQXjw3JdJ8kBhvY0OxJTyx45gmFveCDbQ07igHu`,
  facade: `${CDN}/AB6AXuDdV2PvIX7mpwnAJ0q3TTEIEXhWAgifSY9UUmcAd_gshsvgxvqac3ZOp9dXlWPpx2PETTMuoLO6uLu5z7XwNUf-pQPjht83PnKcsQtsiNUNYVOoIOCtSUtHr9bL_ok9eJyYV3rHPBUfa_gLhCb-SodHAAIVngCteDAOxsu7w5RTHaBuA2iLMcdzHLYYX_iyhfQhvv-6k3p7XTqfIvw32AN4CtwbsP97mEZvJ4p0iEBmwnUX_qDs06oD`,
  lobby: `${CDN}/AB6AXuDjgGRQjFp93q2wvv43gau7Lth3rb3pED6s0mSDq_chSEdwFLe2tzjeAZ__931CP08EuXttrCNvVZNjgb0dtV4OPdRN1TYWAwBc8sUAxYgtXZZWtxD7HE2aV2JkTaXankcfwZhg-pEyxcgcLg-b0i3guz6K7TJN5iclRJGRToIW7uiBy07_37twGaWH5tIa8l4Ev6AdlAvkD4tLclASZbI2B5sKO3808BmGOdb5gqAbsTc76pMRtuRb`,
};

export const INVESTMENT = {
  eyebrow: { ar: "© الاستثمار", en: "© Investment" } as Bilingual,
  title: { ar: "استثمر في أصولٍ تنمو بمرور الزمن", en: "Invest in assets that grow with time" } as Bilingual,
  lead: { ar: "نقدّم فرصاً عقارية مؤسسية بعوائد مستقرة ونموٍ رأسمالي مدعومٍ بجودة معمارية لا تساوم.", en: "We offer institutional real-estate opportunities with stable yields and capital growth backed by uncompromising architectural quality." } as Bilingual,
  image: IMG.tower,
};

export interface Pillar { value: string; label: Bilingual }
export const RETURNS: Pillar[] = [
  { value: "~14%", label: { ar: "عائد سنوي مستهدف", en: "Target annual ROI" } },
  { value: "1.8x", label: { ar: "مضاعف رأس المال", en: "Capital multiple" } },
  { value: "7", label: { ar: "سنوات متوسط الاحتفاظ", en: "Avg. hold (yrs)" } },
  { value: "A+", label: { ar: "التصنيف المالي", en: "Financial rating" } },
];

export interface AssetMetric { value: string; label: Bilingual }
export interface AssetClass {
  slug: string;
  title: Bilingual;
  desc: Bilingual;
  image: string;
  lead: Bilingual;
  body: Bilingual;
  metrics: AssetMetric[];
  highlights: Bilingual[];
}
export const ASSETS: AssetClass[] = [
  {
    slug: "private-unit",
    title: { ar: "استثمار وحدة خاصة", en: "Private Unit Investment" },
    desc: { ar: "تملّك وحدة خاصة بالكامل بعائد إيجاري ونموٍ رأسمالي.", en: "Fully own a private unit with rental yield and capital growth." },
    image: IMG.tower,
    lead: { ar: "تملّك وحدة سكنية خاصة في أرقى مواقع المنصورة، مصمّمة لتجمع بين دخل إيجاري ثابت ونموٍ رأسمالي طويل الأمد.", en: "Own a private residence in Mansoura's finest locations, built to blend steady rental income with long-term capital appreciation." },
    body: { ar: "أنت المالك الكامل للوحدة وتتحكّم في تأجيرها أو إعادة بيعها متى شئت، مع خيار أن نتولّى إدارة التأجير نيابةً عنك لضمان أعلى إشغال وأقل مجهود.", en: "You fully own the unit and control its leasing or resale whenever you wish, with the option to have us manage the rental for maximum occupancy and minimal effort." },
    metrics: [
      { value: "~14%", label: { ar: "عائد سنوي", en: "Annual ROI" } },
      { value: "1.8x", label: { ar: "مضاعف رأس المال", en: "Capital multiple" } },
      { value: "95%", label: { ar: "متوسط الإشغال", en: "Avg. occupancy" } },
    ],
    highlights: [
      { ar: "ملكية كاملة وحرية التصرّف", en: "Full ownership & full control" },
      { ar: "مواقع رئيسية عالية الطلب", en: "Prime, high-demand locations" },
      { ar: "إدارة تأجير اختيارية من تحاور", en: "Optional Tahawer-managed leasing" },
      { ar: "حرية إعادة البيع في أي وقت", en: "Freedom to resell anytime" },
    ],
  },
  {
    slug: "hotel-unit",
    title: { ar: "استثمار وحدة فندقية", en: "Hotel Unit Investment" },
    desc: { ar: "وحدة فندقية مُدارة باحتراف بعائد تشغيلي دون عناء الإدارة.", en: "A professionally-managed hotel unit with hands-free operating income." },
    image: IMG.lobby,
    lead: { ar: "تملّك وحدة داخل مشروع فندقي يديره مشغّل محترف، فتحصل على عائد تشغيلي منتظم دون أي عناء في الإدارة.", en: "Own a unit within a professionally-operated hospitality project and earn regular operating income with zero management hassle." },
    body: { ar: "يتولّى المشغّل الفندقي التأجير والصيانة والخدمة بالكامل، وتحصل أنت على حصتك من الإيرادات وفق اتفاقية واضحة، مع إمكانية استخدامك للوحدة عددًا من الليالي سنويًا.", en: "The hotel operator fully handles leasing, maintenance and service; you receive your share of revenue under a clear agreement, with the option to use the unit for a set number of nights each year." },
    metrics: [
      { value: "~16%", label: { ar: "عائد تشغيلي", en: "Operating yield" } },
      { value: "365d", label: { ar: "إدارة على مدار العام", en: "Managed year-round" } },
      { value: "2x", label: { ar: "مضاعف رأس المال", en: "Capital multiple" } },
    ],
    highlights: [
      { ar: "إدارة فندقية محترفة بالكامل", en: "Fully professional hotel management" },
      { ar: "دخل تشغيلي منتظم دون عناء", en: "Regular, hands-free operating income" },
      { ar: "طلب سياحي وضيافة مرتفع", en: "Strong tourism & hospitality demand" },
      { ar: "ليالٍ مجانية لاستخدام المالك", en: "Complimentary owner-stay nights" },
    ],
  },
];

/** Lookup for the investment detail route. */
export function getAssetClass(slug: string): AssetClass | undefined {
  return ASSETS.find((a) => a.slug === slug);
}

export interface Step { num: string; title: Bilingual; body: Bilingual }
export const PROCESS: Step[] = [
  { num: "01", title: { ar: "اختيار الأصل", en: "Select the asset" }, body: { ar: "نساعدك على اختيار الأصل الأنسب لأهدافك.", en: "We help you pick the asset that fits your goals." } },
  { num: "02", title: { ar: "هيكلة التمويل", en: "Structure financing" }, body: { ar: "خطط سداد مرنة بدون فوائد مخفية.", en: "Flexible plans with no hidden interest." } },
  { num: "03", title: { ar: "التعاقد الموثّق", en: "Secure contracting" }, body: { ar: "توثيق كامل وشفافية في كل خطوة.", en: "Full documentation and transparency at every step." } },
  { num: "04", title: { ar: "العائد والخروج", en: "Yield & exit" }, body: { ar: "متابعة العائد وخيارات خروج مرنة.", en: "Yield tracking with flexible exit options." } },
];

export const INVEST_CLOSING = {
  title: { ar: "لنبنِ محفظتك", en: "Let's build your portfolio" } as Bilingual,
  cta: { ar: "تحدّث إلى مستشار استثماري", en: "Talk to an investment advisor" } as Bilingual,
};
